import { Text } from 'theme-ui';
import React from 'react';
import { GVestSport } from '~/utils/g-vest-sport-font-weight';

const ShowSpecificTitle = ({ titleSmall, titleLarge, hasBody, separateCopy, alignment, mobileTitle }) => {
  const textAlignmentStyle = { textAlign: alignment?.toLowerCase() ?? 'left' };
  const separateCopyMargins = {
    ...(separateCopy && {
      // mb: '1.6rem',
      maxWidth: null,
      width: '100%',
      ...textAlignmentStyle,
    }),
    ...(!separateCopy && {
      mb: hasBody ? 0 : ['1.6rem', '2.4rem'],
      ...textAlignmentStyle,
    }),
  };
  const sharedStyles = {
    textTransform: 'uppercase',
    fontSize: ['2.8rem', '3.6rem'],
    fontWeight: 500,
    lineHeight: '100%',
    maxWidth: separateCopy ? null : [null, '50vw'],

    width: separateCopy && '100%',
    ...textAlignmentStyle,
    ...separateCopyMargins,
  };
  const isGVestSport = (text) => /sport/i.test(text);
  return (
    <>
      {titleSmall &&
        (isGVestSport(titleSmall) ? (
          <Text
            as="h1"
            sx={{
              fontSize: ['2.4rem', '3.2rem'],
              fontWeight: 500,
              lineHeight: ['120%', '100%'],
              textTransform: 'uppercase',
              ...(titleLarge && { mb: [0, 1] }),
              ...(!titleLarge && {
                ...separateCopyMargins,
              }),
            }}
          >
            <GVestSport text={titleSmall} />
          </Text>
        ) : (
          <Text
            as="h1"
            sx={{
              fontSize: ['2.4rem', '3.2rem'],
              textTransform: 'uppercase',
              fontWeight: 500,
              lineHeight: ['120%', '100%'],
              ...(titleLarge && { mb: [0, 1] }),
              ...(!titleLarge && {
                ...separateCopyMargins,
              }),
            }}
            dangerouslySetInnerHTML={{ __html: titleSmall }}
          />
        ))}
      {titleLarge && (
        <>
          {isGVestSport(titleLarge) ? (
            <Text
              as={titleSmall ? 'h2' : 'h1'}
              sx={{
                display: ['none', 'block'],
                ...sharedStyles,
              }}
            >
              <GVestSport text={titleLarge} />
            </Text>
          ) : (
            <Text
              as={titleSmall ? 'h2' : 'h1'}
              dangerouslySetInnerHTML={{ __html: titleLarge }}
              sx={{
                display: ['none', 'block'],
                ...sharedStyles,
              }}
            />
          )}
        </>
      )}
      {mobileTitle &&
        (isGVestSport(mobileTitle) ? (
          <Text
            as={titleSmall ? 'h2' : 'h1'}
            sx={{
              display: ['block', 'none'],
              ...sharedStyles,
            }}
          >
            <GVestSport text={mobileTitle} />
          </Text>
        ) : (
          <Text
            as={titleSmall ? 'h2' : 'h1'}
            dangerouslySetInnerHTML={{ __html: mobileTitle }}
            sx={{
              display: ['block', 'none'],
              ...sharedStyles,
            }}
          />
        ))}
    </>
  );
};

export default ShowSpecificTitle;
